export const canReturnEmail = (loginProvider: string | undefined) => {
  return (
    loginProvider === 'email' ||
    loginProvider === 'google' ||
    loginProvider === 'apple' ||
    loginProvider === 'x'
  )
}
